export default "__VITE_ASSET__BtgqDQMQ__"